exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bt_bg{background-color:#a3adb3}#examPaperCommandWrap .topic .el-input__inner{color:red!important}", ""]);

// exports
